export const CONDITION_RULES = {
  all: 'all',
  any: 'any',
  no: 'no'
}

export const CONDITIONS = {
  SCHOOL: {
    i18nKey: 'admin.crm.condition.name.school',
    value: 'school'
  },
  MAJOR: {
    i18nKey: 'admin.crm.condition.name.major',
    value: 'major'
  },
  COMPANY: {
    i18nKey: 'admin.crm.condition.name.company',
    value: 'company'
  },
  SALARY: {
    i18nKey: 'admin.crm.condition.name.salary',
    value: 'salary'
  },
  EXPERIENCE: {
    i18nKey: 'admin.crm.condition.name.experience',
    value: 'experience'
  },
  AGE: {
    i18nKey: 'admin.crm.condition.name.age',
    value: 'age'
  },
  GENDER: {
    i18nKey: 'admin.crm.condition.name.gender',
    value: 'gender'
  },
  WORK_YEARS: {
    i18nKey: 'admin.crm.condition.name.work_years',
    value: 'work_years'
  },
  LOCATION: {
    i18nKey: 'admin.crm.condition.name.location',
    value: 'location'
  },
  RESUME_KEYWORDS: {
    i18nKey: 'admin.crm.condition.name.resume_keywords',
    value: 'resume_keywords'
  }
}

export const CONDITIONS_IN_RANGE = [
  'salary', 'age', 'work_years'
]

export const CONDITIONS_IN_CONTAINS = [
  'school', 'major', 'company', 'experience', 'location', 'resume_keywords'
]

export const CONDITIONS_IN_EQUALS = [
  'school', 'major', 'company', 'gender'
]

export const CONDITIONS_RELATION_TYPE = {
  CONTAINS: 'contains',
  RANGE: 'range'
}

export const CONDITION_RELATION = {
  EQUALS: 'equals',
  CONTAINS: 'contains',
  MORE: 'more',
  LESS: 'less',
  BETWEEN: 'between'
}

export const VISIBILITY_TYPE = {
  ALL: {
    i18nKey: 'admin.crm.option.talentFilterGroup.all',
    value: 'all'
  },
  PUBLIC: {
    i18nKey: 'admin.crm.option.talentFilterGroup.public',
    value: 'public'
  },
  PRIVATE: {
    i18nKey: 'admin.crm.option.talentFilterGroup.private',
    value: 'private'
  }
}

export const MESSAGE_TYPE = {
  WECHAT_AND_EMAIL: {
    i18nKey: 'admin.crm.option.campaignNotification.wechatAndEmail',
    value: '1'
  },
  EMAIL: {
    i18nKey: 'admin.crm.option.campaignNotification.email',
    value: '2'
  },
  WECHAT: {
    i18nKey: 'admin.crm.option.campaignNotification.wechat',
    value: '3'
  }
}

export const MICROSITE_PATH = {
  INDEX: '/microsite/crm/',
  EDIT: '/microsite-admin/'
}

export const MICROSITE_VISIBILITY_LIST = ['I', 'E', 'IE', 'A']

export const ACCEPT_FILE_TYPE = [
  'image/png',
  'image/jpeg',
  'image/gif',
  'image/jpg'
]

export const ACCEPT_FILE_SIZE = 2 * 1024 * 1024 // 2MB

export const FORM_ITEM_TYPE_LIST = {
  TEXT: {
    i18nKey: 'admin.questionnaire.questionType.text',
    value: 'TEXT'
  },
  DATE: {
    i18nKey: 'admin.questionnaire.questionType.date',
    value: 'DATE'
  },
  SINGLE: {
    i18nKey: 'admin.questionnaire.questionType.single',
    value: 'SINGLE'
  },
  MULTIPLE: {
    i18nKey: 'admin.questionnaire.questionType.multiple',
    value: 'MULTIPLE'
  },
  ATTACHMENT: {
    i18nKey: 'admin.questionnaire.questionType.attachment',
    value: 'ATTACHMENT'
  },
  LINK: {
    i18nKey: 'admin.questionnaire.questionType.link',
    value: 'LINK'
  },
  // LANGUAGE: {
  //   i18nKey: 'admin.questionnaire.questionType.language',
  //   value: 'LANGUAGE'
  // },
  // NATIONALITY: {
  //   i18nKey: 'admin.questionnaire.questionType.nationality',
  //   value: 'NATIONALITY'
  // },
  LOCATION: {
    i18nKey: 'admin.questionnaire.questionType.location',
    value: 'LOCATION'
  }
}

export const HAS_OPTION_FORM_ITEM_TYPE = ['SINGLE', 'MULTIPLE']

export const TAG_TYPE_LIST = [
  'Opened',
  'Shared',
  'Applied for',
  'Screened under',
  'Interviewed under',
  'Hired under',
  'Others',
  'skills',
  'education',
  'work_experience',
  'stability',
  'risks'
]
